<template>
     <section class="toolbar">
         <i class="fa" :class="icon" v-if="this.title"></i><span class="title">{{this.title}}</span>
         <el-button v-if="back" @click="backFun" type="danger">返回</el-button>
         <slot class="fr"></slot>
     </section>
</template>

<script>
import { ICON_DEFAULT } from '@/constant'
export default {
    props: {
        // 标题
        title: {
            type: String,
            default: ''
        },
        // 图标
        icon: {
            type: String,
            default: ICON_DEFAULT
        },
        // 返回方法
        back: {
            type: [Boolean, String, Function]
        }
    },
    methods: {
        backFun() {
            if (typeof this.back === 'boolean') {
                this.$emit('updateState', 'List')
            } else if (typeof this.back === 'string') {
                this.$emit('updateState', this.back)
            } else if (typeof this.back === 'function') {
                this.back()
            }
            this.$router.replace({})
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/styles/var.scss';
.el-button + .el-button {
  margin-left: 0px;
}
.title {
  //   color: #606266;
  font-weight: 600;
  color: #4a6076;
  font-size: 16px;
  line-height: 36px;
  margin-left: 2px;
}
.toolbar {
  border-bottom: 4px solid $--color-line;
  margin-bottom: 10px;
  .el-input {
    width: inherit;
    float: right;
    margin-right: 15px;
    margin-top: 3px;
  }
  .el-select {
    float: right;
    margin-right: 15px;
    margin-top: 3px;
  }
  .el-button {
    float: right;
    margin: 3px 10px 3px 0;
  }
  .el-dropdown {
      float: right;
      margin: 3px 10px 3px 0;
  }
  .mr50 {
    margin-right: 50px !important;
  }
}
@media screen and (max-width: 1400px) {
  .toolbar {
    .el-input {
      width: 150px;
      float: right;
      margin-right: 15px;
      margin-top: 3px;
    }
    .el-select {
      width: 150px;
      float: right;
      margin-right: 15px;
      margin-top: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CHead.vue